<template>
  <div :class="[baseCss, truncate ? 'truncate' : null]">
    <slot />
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'ListItemContentTitle',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('list-item-content-title', ['text-sm', 'font-semibold'])
    }
  },
  props: {
    truncate: {
      type: Boolean,
      default: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/list-item-content-title/list-item-content-title.vue